export default __webpack_public_path__ + "static/tbb-9ba7ce4a69c78ac6ea1e23b86cc70314.png";